import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  hover?: boolean
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  hover = false,
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }

  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-lg shadow ${
        hover ? 'transition-all hover:shadow-lg' : ''
      } ${paddingClasses[padding]} ${className}`}
    >
      {children}
    </div>
  )
}

